import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OfferCardStat from '../OfferStat';
import { PromoterOfferDto } from 'legacy/events/types';
import { IoMdPause } from 'react-icons/io';
import { FaPlayCircle } from 'react-icons/fa';
import EditPromoterStatusModal from '../modals/EditPromoterStatusModal';
import { BsThreeDots } from 'react-icons/bs';
import OfferActionModal from '../modals/OfferActionModal';
import { OffersStep } from 'legacy/events/offers.types';
import DeletePromoterOfferModal from '../modals/DeletePromoterOfferModal';
import { currencyFormat } from 'legacy/common/utils/currency';

const OfferCard = ({
  offer,
  handleDeletePromoterOffer,
  handleOfferClick,
  setOffersStep,
  setOfferId
}: {
  offer: PromoterOfferDto;
  handleDeletePromoterOffer: (offerId: string, callback: () => void) => void;
  handleOfferClick: (offerId: string) => void;
  setOffersStep: (step: OffersStep) => void;
  setOfferId: (offerId: string) => void;
}) => {
  const { t } = useTranslation(['events']);
  const [isPausePromoterModalOpen, setIsPausePromoterModalOpen] =
    useState(false);
  const [isPausedPromoter, setIsPausedPromoter] = useState(!offer.isActive);
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [isDeletePromoterOfferModalOpen, setIsDeletePromoterOfferModalOpen] =
    useState(false);

  useEffect(() => {
    setIsPausedPromoter(!offer.isActive);
  }, [offer.isActive]);

  const hanleClick = (e) => {
    e.stopPropagation();
    setIsActionModalOpen(true);
  };

  const handlePausePromoterClick = (e) => {
    e.stopPropagation();
    setIsPausePromoterModalOpen(true);
  };

  const handleDeletePromoterOfferClick = (e) => {
    e.stopPropagation();
    setIsDeletePromoterOfferModalOpen(false);
    setIsActionModalOpen(false);
  };

  const handleOfferDetailsClick = () => {
    setOfferId(offer.id);
    setOffersStep(OffersStep.OFFER_DETAILS);
  };

  return (
    <div
      className={`border-1 border-[#EBEBEB] rounded-lg ${
        isPausedPromoter ? 'bg-[#F6F6F6]' : ''
      }`}
    >
      <div className="p-4" onClick={() => handleOfferClick(offer.id)}>
        <div className="flex flex-row items-center justify-between">
          <div
            className={`font-bold text-base ${
              isPausedPromoter ? 'text-[#575757]' : ''
            }`}
          >
            {offer.name}
          </div>
          <BsThreeDots
            className="text-[#787878]"
            size={20}
            onClick={hanleClick}
          />
        </div>
        <div className="flex items-center gap-2">
          <div className="text-sm font-normal py-4">🗣️</div>
          <div
            className={`text-sm font-normal py-4 ${
              isPausedPromoter ? 'text-[#575757]' : 'text-[#202020]'
            }`}
          >
            {offer.activePromoters}{' '}
            {t('settings.promoterOffers.offerCard.activePromoters')}
          </div>
        </div>
        {!isPausedPromoter ? (
          <div
            className="flex items-center justify-center gap-2 border border-[#EFF2FF] rounded-2xl p-2"
            onClick={handlePausePromoterClick}
          >
            <div className="text-sm font-bold text-[#3853C4]">
              {t('settings.promoterOffers.offerCard.pauseOffer')}
            </div>
            <IoMdPause className="text-[#3853C4]" size={14} />
          </div>
        ) : (
          <div
            className="flex items-center justify-center gap-2 border border-[#EFF2FF] rounded-2xl p-2 bg-[#EFF2FF]"
            onClick={handlePausePromoterClick}
          >
            <div className="text-sm font-bold text-[#3853C4]">
              {t('settings.promoterOffers.offerCard.resumeOffer')}
            </div>
            <FaPlayCircle className="text-[#3853C4]" size={14} />
          </div>
        )}
      </div>
      <div className="h-[1px] bg-[#EBEBEB] w-full" />
      <div className="flex flex-row items-center p-4">
        <OfferCardStat
          title={t('settings.promoterOffers.offerCard.views')}
          description={offer.analytics?.views?.toString() || '0'}
        />
        <OfferCardStat
          title={t('settings.promoterOffers.offerCard.eligibleSales')}
          description={offer.analytics?.sales?.toString() || '0'}
        />
        <OfferCardStat
          title={t('settings.promoterOffers.offerCard.revenue')}
          description={currencyFormat(offer.analytics?.revenue)}
        />
        <OfferCardStat
          title={t('settings.promoterOffers.offerCard.earnings')}
          description={currencyFormat(offer.analytics?.earnings)}
        />
      </div>
      {isPausePromoterModalOpen && (
        <EditPromoterStatusModal
          onClose={() => setIsPausePromoterModalOpen((prev) => !prev)}
          eventId={offer.eventId}
          offerId={offer.id}
          isActive={offer.isActive}
          onSuccess={() => {
            setIsPausePromoterModalOpen(false);
          }}
        />
      )}
      {isActionModalOpen && (
        <OfferActionModal
          offer={offer}
          onClose={() => setIsActionModalOpen(false)}
          handleDeletePromoterOffer={() =>
            setIsDeletePromoterOfferModalOpen(true)
          }
          handleOfferDetails={handleOfferDetailsClick}
        />
      )}
      {isDeletePromoterOfferModalOpen && (
        <DeletePromoterOfferModal
          onClose={() => setIsDeletePromoterOfferModalOpen(false)}
          handleDeletePromoterOffer={() =>
            handleDeletePromoterOffer(
              offer.id,
              () => handleDeletePromoterOfferClick
            )
          }
        />
      )}
    </div>
  );
};
export default OfferCard;
